/**
 * This is a regular expression that captures in a key value relationship the values in a query string
 *
 * [?&]       First we look back to make sure that we are starting with either ? or &               & or ?
 *
 *                  This next part captures the key=value relationship
 *
 *    (?:([^&=]*) Here we capture the key, which can contain any value except for = or &               key
 *    (?:=?)     Here we have the option for having an = since in some cases we may have &key&        =
 *    ([^&]*))     We now capture the value part if there where a = before it                           value
 *
 * (?=&])?         Lastly we look forward to find an optional & to end our capture, since we            & or $
 *                  may have &key=value where there is no & to end on
 * @type {RegExp}
 */
export const QueryReg = /[?&](?:([^&=]*)(?:=?)([^&]*))(?=&)?/g
